import React from 'react';

function ResponsiveImg({ src, widths = [400, 600, 800, 1000, 1200, 1600, 2000], sizes, alt, ...rest }) {
  const imgName = src.replace(/\.[^/.]+$/, '');
  const imgExt = src.match(/\.[^/.]+$/)?.[0] || '';
  const srcSet = widths.map(size => `${imgName}-${size}w${imgExt} ${size}w`).join(', ');
  const defaultSrc = `${imgName}-${widths[widths.length - 2]}w${imgExt}`;

  return (
    <img
      srcSet={srcSet}
      sizes={`auto, ${sizes || '100vw'}`}
      src={defaultSrc}
      alt={alt}
      {...rest}
    />
  );
}

export default ResponsiveImg;
